(() => {
  'use strict';

  const config = window.FramewerkSearchConfig || {};
  const clean = (value = '') => String(value).toLowerCase().replace(/\s+/g, ' ').trim();
  const compact = (value = '') => clean(value).replace(/[^a-z0-9]/g, '');
  const variants = (product) => Array.isArray(product?.variants) ? product.variants : [];

  const score = (product, query, interpretation = null) => {
    const q = clean(query);
    const title = clean(product?.title);
    const type = clean(product?.product_type);
    const tags = Array.isArray(product?.tags) ? clean(product.tags.join(' ')) : clean(product?.tags);
    const body = clean(product?.body || product?.description);
    const searchable = `${title} ${type} ${tags} ${body}`;
    const words = q.split(/\s+/).filter((word) => word.length > 1);
    let points = 0;

    const targetSku = compact(query);
    if (targetSku && variants(product).some((variant) => compact(variant?.sku) === targetSku)) points += 5000;
    if (title === q) points += 1800;
    if (title.startsWith(q)) points += 900;
    if (title.includes(q)) points += 520;

    words.forEach((word) => {
      if (title.includes(word)) points += 110;
      else if (type.includes(word)) points += 55;
      else if (tags.includes(word)) points += 40;
      else if (body.includes(word)) points += 12;
    });

    const models = config.modelCodes || [];
    const vehicle = q.match(new RegExp(`\\b(${models.join('|')})\\b`, 'i'))?.[1]?.toUpperCase() || '';
    if (vehicle) {
      const pattern = new RegExp(`\\b${vehicle}\\b`, 'i');
      if (pattern.test(product?.title || '')) points += 650;
      else if (pattern.test(searchable)) points += 220;
      else points -= 120;
    }

    if (interpretation?.intentId === 'radio') {
      if (/\b(radio|carplay|android auto|head unit|stereo)\b/i.test(searchable)) points += 180;
      if (/\b(fascia|surround|harness|aerial adaptor|antenna adaptor)\b/i.test(title)) points -= 30;
    }
    if (interpretation?.intentId === 'radio-fascia' && /\b(fascia|surround|bezel|trim)\b/i.test(title)) points += 320;
    if (interpretation?.intentId === 'door-belt' && /\b(door belt|belt mould|window scraper)\b/i.test(title)) points += 320;
    if (product?.available !== false) points += 35;
    return points;
  };

  window.FramewerkSearchRanker = Object.freeze({ version: '2.0.0', score });
})();
